import Head from 'next/head';
import parseHtml from 'html-react-parser';
import React, {useEffect} from 'react';
import {GetServerSideProps} from 'next';
import {NextPageWithPageLayoutOptions} from '../../components/page-layout/types';
import {setBodyClass, parseOptions} from '../../utils/webflow-util';

const MembershipPage: NextPageWithPageLayoutOptions = (props: any) => {
  useEffect(() => {
    setBodyClass('tokentraxx-body');
  }, []);
  if (!props.headContent && !props.bodyContent) {
    return <></>;
  }
  return (
    <>
      <Head>
        {parseHtml(props.headContent, parseOptions)}
        <script
          defer
          crossOrigin="anonymous"
          data-domain="tokentraxx.com"
          src="https://plausible.io/js/script.js"
        />
        Testing
        <script>
          {`window.plausible = window.plausible || function(){(window.plausible.q = window.plausible.q || []).push(arguments)}`}
        </script>
      </Head>
      {parseHtml(props.bodyContent, parseOptions)}
    </>
  );
};

export const getStaticProps: GetServerSideProps = async () => {
  const cheerio = await import(`cheerio`);
  const axios = (await import(`axios`)).default;

  // Use path to determine Webflow path
  const url = 'membership-new';
  const fetchUrl = process.env.WEBFLOW_URL + url;

  // Fetch HTML
  const res: any = await axios(fetchUrl);
  const html = res.data;

  // Parse HTML with Cheerio
  const $ = cheerio.load(html);

  const bodyContent = $(`body`).html();
  const headContent = $(`head`).html();

  return {
    props: {
      bodyContent,
      headContent,
    },
  };
};

export default MembershipPage;
